
import React from 'react';
import MuiDialog from '@mui/material/Dialog';

const DialogDraggable = (props) => <MuiDialog aria-labelledby="draggable-dialog-title" {...props} />;

export default DialogDraggable;
